module.exports = __webpack_public_path__ + "img/ic_result02.e0193f71.png";